import React, { useState } from 'react';
import { Button as ANTButton, Form, notification, Space } from 'antd';
import { Button } from '../../../components/Atom/Button';
import Input from 'components/Atom/Input';
import Select from 'components/Atom/Select';
import http from '../../../utils/http';
const AppOnboarding = ({ handleOpen, handleUpdate, store }) => {
  const [loading, setLoading] = useState(false);
  const [source, setSource] = useState('shopify');
  const handleSourceChange = (e) => {
    setSource(e.value);
  };
  const sourceData = [
    {
      label: 'SHOPIFY',
      value: 'shopify',
    },
  ];
  const initialValues = {
    domain: store?.ecommerceChannel?.domain,
    accessToken: store?.ecommerceChannel?.accessToken,
    storefrontToken: store?.ecommerceChannel?.storefrontToken,
    secretKey: store?.ecommerceChannel?.secretKey,
  };
  const onSubmit = async (data) => {
    setLoading(true);
    try {
      let payload;
      if (source === 'shopify') {
        const { domain, accessToken, storefrontToken, secretKey } = data;
        payload = { type: source, domain, accessToken, storefrontToken, secretKey };
        let response;
        if (store?.ecommerceChannel?.domain) {
          response = await http.put(`/stores/shopify/app/${store?._id}`, payload);
        } else {
          response = await http.post(`/stores/shopify/app/${store?._id}`, payload);
        }
        setLoading(false);
        handleUpdate(response?.data?.data);
        notification.success({ message: `SHOPIFY APP ${store?.ecommerceChannel?.domain ? 'UPDATE' : 'INTEGRATED'} SUCCESSFULLY`, placement: 'bottomRight' });
      }
    } catch (err) {
      setLoading(false);
      notification.error({ message: err?.response?.data?.message || 'SOMETHING WENT WRONG', placement: 'bottomRight' });
    }
    handleOpen();
  };
  return (
    <Form layout='vertical' onFinish={onSubmit} initialValues={initialValues}>
      <Form.Item className='customSelect' label='App'>
        <Select handleChange={handleSourceChange} optionsValue={sourceData} />
      </Form.Item>

      <Form.Item
        className='customInputLayout'
        name='domain'
        label={source === 'shopify' ? 'Domain' : 'Email / Domain'}
        rules={[
          {
            required: true,
            message: source === 'shopify' ? 'Domain is required' : 'Email / Domain is required',
          },
        ]}>
        <Input placeholder={source === 'shopify' ? 'Enter domain' : 'Enter email or  domain'} name='domain' />
      </Form.Item>
      {source === 'shopify' && (
        <>
          <Form.Item
            className='customInputLayout'
            name='accessToken'
            label='Access Token'
            rules={[
              {
                required: true,
                message: 'Access Token is required',
              },
            ]}>
            <Input placeholder='Enter access token' name='accessToken' />
          </Form.Item>
          <Form.Item
            className='customInputLayout'
            name='storefrontToken'
            label='Storefront Token'
            rules={[
              {
                required: true,
                message: 'Storefront Token is required',
              },
            ]}>
            <Input placeholder='Enter storefront token' name='storefrontToken' />
          </Form.Item>
          <Form.Item
            className='customInputLayout'
            name='secretKey'
            label='Secret Key'
            rules={[
              {
                required: true,
                message: 'Secret Key is required',
              },
            ]}>
            <Input placeholder='Enter secret Key' name='secretKey' />
          </Form.Item>
        </>
      )}
      <Form.Item>
        <div className='flex'>
          <ANTButton className='rounded-lg' block onClick={() => handleOpen()}>
            Cancel
          </ANTButton>
          <Button block className='primaryBtn ml-4' type='primary' htmlType='submit' loading={loading}>
            Submit
          </Button>
        </div>
      </Form.Item>
    </Form>
  );
};
export default AppOnboarding;
